import { render, staticRenderFns } from "./MatManMatch.vue?vue&type=template&id=5393e8d6&scoped=true&"
import script from "./MatManMatch.vue?vue&type=script&lang=js&"
export * from "./MatManMatch.vue?vue&type=script&lang=js&"
import style0 from "./MatManMatch.vue?vue&type=style&index=0&id=5393e8d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5393e8d6",
  null
  
)

export default component.exports